import MagnifyingGlass from './MagnifyingGlass'

export default MagnifyingGlass
